import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { NoticeStatus } from 'store/ducks/notice/types';
import { AppState } from 'store/store';
import { classRoomsServices } from 'api/services';
import { ShowNotification } from 'helpers/showNotice';
import { MainLoader } from 'components/Loader/Loader';
import Template from 'components/Template/Template';
import * as serviceActions from 'store/ducks/services/actions';
import {
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material';
import './CreateClassRoomPage.sass';
import { useNavigate } from 'react-router'

export const CreateClassRoomPage: React.FC = () => {
  const [hasError, setHasError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState('');
  const [selectedBranch, setSelectedBranch] = useState('');
  const i18n = useSelector(
    (state: AppState) => state.i18n.data.pages.CreateClassRoomPage
  );
  const { branches } = useSelector((state: AppState) => state.services);
  const lang = useSelector((state: AppState) => state.i18n.key);

  const history = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    getBranchs();
  }, []);

  const createClassRoom = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    if (!name.trim()) {
      setHasError(true);
      ShowNotification(i18n.fillFields);
      setLoading(false);
      return;
    }
    try {
      await classRoomsServices.createClassRoom({
        name,
        branchId: Number(selectedBranch),
      });
      history('/cabinets');
      ShowNotification(i18n.createdClassRoom, NoticeStatus.SUCCESS);
      dispatch(serviceActions.getBranches());
    } catch {
      ShowNotification(i18n.nameError);
      setLoading(false);
    }
  };

  const getBranchs = () => {
    if (!branches.length) dispatch(serviceActions.getBranches());
  };

  return (
    <Template>
      <div className='create-class-room-page'>
        <Typography variant='h3'>{i18n.createClassRoom}</Typography>
        <form
          className='create-class-room-page__form'
          onSubmit={createClassRoom}
        >
          <Grid
            className='row'
            container
            spacing={2}
            item
            xs={6}
            alignItems='flex-end'
          >
            <Grid item xs={12}>
              <TextField
                variant='outlined'
                fullWidth
                className='create-class-room-page__field'
                autoComplete='off'
                size='small'
                label={i18n.name}
                value={name}
                error={hasError && !name.trim()}
                onChange={(e) => setName(e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              {!!branches.length && (
                <FormControl fullWidth variant='outlined' size='small'>
                  <InputLabel id='role'>{i18n.choiceBranch}</InputLabel>
                  <Select
                    onChange={(e) => setSelectedBranch(e.target.value)}
                    value={selectedBranch}
                    variant='outlined'
                    size='small'
                    labelId='role'
                    label={i18n.choiceBranch}
                  >
                    {branches.map((i) => (
                      <MenuItem key={i.id} value={i.id}>
                        {i[`name${lang}`]}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}
            </Grid>
          </Grid>
          <Grid
            container
            spacing={2}
            className='create-class-room-page__button-wrap'
            item
            xs={6}
          >
            <Grid item xs={6}>
              <Link className='create-class-room-page__button' to='/cabinets'>
                <Button
                  variant='contained'
                  color='inherit'
                  className='create-class-room-page__button'
                  size='large'
                >
                  {i18n.back}
                </Button>
              </Link>
            </Grid>
            <Grid item xs={6}>
              <Button
                variant='contained'
                color='success'
                className='create-class-room-page__button'
                type='submit'
                disabled={loading}
                size='large'
              >
                {loading ? <MainLoader /> : i18n.save}
              </Button>
            </Grid>
          </Grid>
        </form>
      </div>
    </Template>
  );
};
